import React from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { BasicModal } from "../../../Shared";
import { useLanguage } from "../../../../contexts";
import { determineSocialUnits } from "../../../../utils/dataAndFormulas/socialForms";
import "./UnitsForm.scss";

export function UnitsForm(props) {
  const { show, onClose, onSave, currentUnits, registeredFields } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Todos los campos de social con sus 24 campos
  const allSocialFields = [
    { key: "days_worked", label: t("days_worked") },
    { key: "normal_hours_worked", label: t("normal_hours_worked") },
    { key: "fifty_percent_overtime", label: t("fifty_percent_overtime") },
    {
      key: "one_hundred_percent_overtime",
      label: t("one_hundred_percent_overtime"),
    },
    { key: "female_production_workers", label: t("female_production_workers") },
    { key: "male_production_workers", label: t("male_production_workers") },
    {
      key: "other_gender_production_workers",
      label: t("other_gender_production_workers"),
    },
    {
      key: "female_administrative_workers",
      label: t("female_administrative_workers"),
    },
    {
      key: "male_administrative_workers",
      label: t("male_administrative_workers"),
    },
    {
      key: "administrative_workers_other_genders",
      label: t("administrative_workers_other_genders"),
    },
    { key: "female_temporary_workers", label: t("female_temporary_workers") },
    { key: "male_temporary_workers", label: t("male_temporary_workers") },
    {
      key: "temporary_workers_other_genders",
      label: t("temporary_workers_other_genders"),
    },
    {
      key: "female_workers_leadership_positions",
      label: t("female_workers_leadership_positions"),
    },
    {
      key: "male_workers_leadership_positions",
      label: t("male_workers_leadership_positions"),
    },
    { key: "workers_under_cct", label: t("workers_under_cct") },
    {
      key: "work_accidents_with_sick_days",
      label: t("work_accidents_with_sick_days"),
    },
    { key: "in_itine_accidents", label: t("in_itine_accidents") },
    {
      key: "first_aid_without_sick_days",
      label: t("first_aid_without_sick_days"),
    },
    {
      key: "hours_training_social_issues",
      label: t("hours_training_social_issues"),
    },
    { key: "hours_training_hys", label: t("hours_training_hys") },
    {
      key: "hours_environmental_awareness_training",
      label: t("hours_environmental_awareness_training"),
    },
    { key: "volunteer_hours", label: t("volunteer_hours") },
    {
      key: "complaints_or_suggestions_received",
      label: t("complaints_or_suggestions_received"),
    },
  ];

  // Si hay campos registrados en el Form, usar solo los activos; si no, usar todos
  const socialFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
          }))
      : allSocialFields;

  // Debug: Ver qué opciones genera determineSocialUnits
  React.useEffect(() => {
    if (socialFields.length > 0) {
      const firstField = socialFields[0].key;
      const options = determineSocialUnits(firstField);
      console.log(
        "🔍 UnitsForm - Opciones disponibles para",
        firstField,
        ":",
        options
      );
      // console.log("🔍 UnitsForm - socialFields:", socialFields);
      // console.log("🔍 UnitsForm - currentUnits:", currentUnits);
    }
  }, [socialFields, currentUnits]);

  const formik = useFormik({
    initialValues: socialFields.reduce((acc, field) => {
      // Si ya existe una unidad guardada, usarla; si no, dejar vacío
      const currentValue = currentUnits?.[field.key];
      acc[field.key] =
        currentValue !== null && currentValue !== undefined ? currentValue : "";
      return acc;
    }, {}),
    enableReinitialize: true,
    onSubmit: (values) => {
      onSave(values);
      onClose();
    },
  });

  return (
    <BasicModal
      show={show}
      close={onClose}
      size="large"
      className="units-form-modal"
    >
      <Form onSubmit={formik.handleSubmit} className="units-form-modal">
        <div className="units-form-modal__title">{t("configure_units")}</div>
        <div className="units-grid">
          {socialFields.map((field) => (
            <div key={field.key} className="unit-row">
              <span className="unit-label">{field.label}</span>
              <Dropdown
                placeholder={t("select_unit")}
                fluid
                selection
                search
                clearable
                options={determineSocialUnits(field.key).map((u) => ({
                  key: u.key,
                  value: u.value,
                  text: u.name,
                }))}
                value={formik.values[field.key]}
                onChange={(_, data) =>
                  formik.setFieldValue(field.key, data.value)
                }
              />
            </div>
          ))}
        </div>

        <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "8px" }}>
          <Button primary onClick={formik.handleSubmit}>
            {t("save")}
          </Button>
          <Button onClick={onClose} className="units-btn-cancel">
            {t("cancel")}
          </Button>
        </div>
      </Form>
    </BasicModal>
  );
}
